import React, { useState, useEffect } from "react";

import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import gettogether2026 from "../images/get together misaa.jpeg";


export default function AutoPopup() {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => {
            setOpen(true); // show popup automatically
        }, 1500);

        return () => clearTimeout(timer);
    }, []);

    const closePopup = () => setOpen(false);

    return (
        <>
        <br/>
        <br/>
        <br/>
            {open && (
                   
                <div className="popup-overlay" onClick={closePopup}>
                    <div className="popup-box" onClick={(e) => e.stopPropagation()}>
      
                        {/* Close Button */}
                        <button className="popup-close" onClick={closePopup}>×</button>

                        {/* Popup Content */}
                        <br />
                        <br />
                         
 <div
                      style={{
                        height: '450px',
                        overflowY: 'scroll',
                        border: '0px solid #ccc',
                        padding: '1rem',
                      }}
                    >
                        <Zoom>
                            <img src={gettogether2026} className="card-img-top mb-2" alt="gettogether2026" />
                        </Zoom>
                       

                        <h5  style={{color:"#021a77"}} className="justify mt-1"><b>
</b></h5>
<p style={{color:"#0a4e10"}}>
   THE ANNUAL FOOTBALL MATCH between M.I.S & M.I.S.A.A will also be held on the same date i.e 20th December 2026 at 01:30 PM in M.I.S grounds. Interested alumni can submit your names to V.P Kasem Mallick/Treasurer Anirban Chandra/Social Initiatives Team Leader Rajorshi Mondal.

</p>
                       

{/* <center>
    <a href="TaruRakhiBandhan2026">
<button className="photob mb-2">View/More Photo <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708"/>
  <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708"/>
</svg></button>
</a>
</center> */}

                        <button className="popup-btn mt-1" onClick={closePopup}>
                            Close
                        </button>

                  
                    </div>
                </div>
                  </div>
                  
            )}
        </>
    );
}
